<template>
  <div>
    <div class="top-navbar">
      <a href="javascript:closePage()" class="back-arrow">
        <i class="icon dripicons-chevron-left"></i>
      </a>
        {{ $t('detail') }}
    </div>
    <div class="container mt-3">
      <table class="tablestyle">
        <thead>
          <tr>
            <th>{{ $t('no.') }}</th>
            <th style="width: 100px;min-width: 100px;max-width: 100px;">
              {{ $t('datetime') }}
            </th>
            <th>{{ $t('game') }}</th>
            <th>{{ $t('withdraw_number') }}</th>
            <th>{{ $t('bet_type') }}</th>
            <th class="text-right">Tiền&nbsp;Cược</th>
            <th>Lựa&nbsp;Chọn</th>
            <th>Tỷ&nbsp;lệ</th>
            <th class="text-right">Thắng&nbsp;/&nbsp;Thua</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="detail !== null">
          <tr
            v-for="(row, index) in detail.content" :key="index"
            class="tableRow tableRow-pointer"
            valign="middle"
          >
            <td>{{ row.id }}</td>
            <td>{{ row.createdDate }}</td>
            <td>
              {{ $t("tables." + row.round.table.id) }}
            </td>
            <td>
              {{ $t('no.') }}&nbsp;{{ row.round.id }}
            </td>
            <td>
              {{ getBetTypeGroup(row.round.table.groupName, row.betType) }}
            </td>
            <td class="text-right">
              {{ formatAmountWinTotal(row.amount) }}
            </td>
            <td>
              {{ getBetType(row.round.table.groupName, row.betType) }}
            </td>
            <td>
              {{ row.rate.toFixed(2) }}
            </td>
            <td class="text-right">
              <span style="color:green;" :class="'-' + row.status">
                {{ formatAmountWinTotal(row.amountWin) }}
              </span>
            </td>
            <td :ref="'result_' + row.id" >
              <a tabindex="0" role="button" style="cursor:pointer;" data-toggle="popover" data-placement="bottom" data-original-title="" title="">
                <div
                  :id="'result_' + row.id"
                  :name="$t('tables.' + row.round.table.id)"
                  :groupName="row.round.table.groupName"
                  :value="JSON.stringify(row.round)"
                  :round="row.round.id"
                  :createdDate="row.round.createdDate"
                  @click="showDetail"
                >
                  {{ $t('result') }}
                </div>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <HistoryDetail
        :popover-options="popoverOptions"
        :is-popover-visible="isPopoverVisible"
        :round-data="roundData"
        @closePopover="closePopover"
      />
    </div>
    <div style="display: flex; justify-content: center; margin-top: 10px;">
      <Pagination
        :page="currentPage"
        :total-page="totalPage"
        :handler-page="loadPage"
      />
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import HistoryDetail from '@components/common/history/history-detail.vue';
import Pagination from '@components/common/pagination.vue';
import { getBetTypeValue, getBetTypeGroupValue } from '@utils/betType.js';
import {calculateScore as calculateAtomScore} from '@handlers/atom/result.js';
import {calculateScore as calculateAtomWarScore} from '@handlers/atomwar/result.js';
import i18n from "@src/i18n";

const PAGE_SIZE = 20;

export default {
  components: {
    HistoryDetail, Pagination,
  },
  data() {
    return {
      page: "",
      currentPage: 1,
      status: "LOADING",
      isPopoverVisible: false,
      popoverOptions: {
        animation: "scale-fade",
        popoverReference: null,
        placement: "bottom-end",
        offset: "0,0"
      },
      roundData: {
        value: "",
        round: 0,
        score: {},
        createdDate: "",
      }
    }
  },
  computed: {
    ...mapState('dailyStatement', ['detail']),
    totalPage: function(){
      if(this.detail === null) return 0;
      const total = Math.floor(this.detail.total / PAGE_SIZE);
      console.log('totalPage', this.detail.total, total);
      return total;
    },
  },
  watch: {
    detail: function(newVal){
      const pages = Math.ceil(newVal.total/PAGE_SIZE);
      this.page = `Trang ${this.currentPage}/${pages}`;
      this.status = "DONE";
    },
  },
  mounted() {
    this.getData();
    const lang = this.$route.query.lang;
    if (lang !== undefined && lang !== "") {
      i18n.locale = lang;
    }
  },
  methods: {
    ...mapActions('dailyStatement', ['getDailyStatementDetail']),
    getData: function() {
      this.status = "LOADING";
      const { token, date } = this.$router.currentRoute.query;
      this.getDailyStatementDetail({token, date, limit: PAGE_SIZE, page: this.currentPage - 1});
    },
    getBetType: function(game, val){
      return getBetTypeValue(game, val);
    },
    getBetTypeGroup: function(game, val){
      return getBetTypeGroupValue(game, val);
    },
    previousPage(event, value) {
      if(this.currentPage > 1){
        this.currentPage -= 1;
        this.getData();
      }
    },
    nextPage(event, value) {
      const pages = Math.ceil(this.detail.total/PAGE_SIZE);
      if(this.currentPage < pages){
        this.currentPage += 1;
        this.getData();
      }
    },
    firstPage(event, value) {
      this.currentPage = 1;
      this.getData();
    },
    lastPage(event, value) {
      this.currentPage = Math.ceil(this.detail.total/PAGE_SIZE);
      this.getData();
    },
    onChange(event) {
      const tableId = event.target.value;
      // console.log(tableId);
      this.tableId = tableId;
      this.getData();
    },
    formatAmountWinTotal: function(value){
      if((value === undefined || value === "") && value !== 0) {
        console.log('value:', value);
        return "Chưa xác định";
      }
      return Number(value).toLocaleString()
    },
    formatJackpot: function(value){
      if(value === undefined || value === "") return "--";
      return Number(value).toLocaleString()
    },
    showResultPage: function(date){
      const { token } = this.$router.currentRoute.query;
      const url = `/dailystatement?token=${token}`;
      this.$router.push(url)
    },
    closePopover() {
      // console.log('closePopover')
      this.isPopoverVisible = false
    },
    showDetail(e) {
      const id = e.target.getAttribute("id");
      const value = JSON.parse(e.target.getAttribute("value"));
      const round = e.target.getAttribute("round");
      const createdDate = e.target.getAttribute("createdDate");
      const groupName = e.target.getAttribute("groupName");
      const name = e.target.getAttribute("name");
      const ref = this.$refs[id][0];
      let score = {};
      let game = 1;
      // console.log('showDetail', game, groupName, value, score);
      switch(groupName){
        case "atom":
          game = 1;
          score = calculateAtomScore(value);
          break;
        case "atom_war":
          game = 2;
          score = calculateAtomWarScore(value);
          break;
      }
      // console.log('showDetail', game, groupName, value, score);

      this.popoverOptions.popoverReference = ref;
      this.roundData = { ref, name, game, score, value, round, createdDate };
      this.isPopoverVisible = true;
    },
    loadPage(event) {
      // console.log('loadPage', event);
      this.currentPage = event;
      this.getData();
    }
  }
}
</script>

<style>
  /* body, #app {
    background: none;
  } */
  .-LOSE {
    color: #ac3f37!important;
  }

  .flipResult-sd-container-numbers {
    padding: 15px 50px 15px 50px;
  }

  .flipResult-sd-container-sedie {
    display: -webkit-box;
    display: flex;
    width: 100%;
    -webkit-box-align: center;
    align-items: center;
    justify-content: space-around;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .flipResult-sd-red {
    border: solid .5px #7a7a7a;
    box-shadow: 1px 1px 1px #AAA;
    color: white;
  }

  .flipResult-sd-ball {
    width: 30px;
    height: 30px;
    border-radius: 40px;
    font-size: 16px;
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  }

  .flipResult-sd-red {
    border: solid .5px #7a7a7a;
    box-shadow: 1px 1px 1px #AAA;
    color: white;
  }
  .flipResult-sd-white {
    background-color: white;
    border: solid .5px #7a7a7a;
    box-shadow: 1px 1px 1px #AAA;
    color: #ac3f37;
  }

  .flipResult-sd-container-sum-left {
    width: calc(100%/3);
  }

  .flipResult-sd-container-sum-right {
    width: calc(100%*2/3);
  }

  .flipResult-sd-vline {
    width: 2px;
    height: 42px;
  }

  .flipResult-sd-sum-result {
    height: 24px;
  }

  .bg_ad0707 {
    color: rgb(255, 255, 255);
  }

  .flipResult-sd-sum-ball {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    margin-right: 6px;
    border: solid .5px #7a7a7a;
    box-shadow: 1px 1px 1px #AAA;
  }
  .flipResult-sd-sum-number {
    font-size: 16px;
    font-weight: bold;
  }
</style>
